import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './styles.css';

/**
 *  SiteSearchMb
 */
class SiteSearchMb extends Component {
  static propTypes = {
    searchCode: PropTypes.string,
    scrollToSearchTop: PropTypes.func,
  };
  static defaultProps = {
    searchCode: null,
    scrollToSearchTop: null,
  };

  constructor(props) {
    super();
    this.props = props;
    this.state = {
      open: false,
      height: 0,
    };
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  render() {
    return (
      <div className={'SiteSearch mb' + ((this.state.open === true) ? ' open': '')}
           ref="content"
      >
        <div className="SiteSearch__container"
             style={{height: this.state.height}}
        >
          <div className="SiteSearch__inner">
            <div className="SiteSearch__code"
                 ref="code"
            >
              {(this.props.searchCode !== null) ?
                <div dangerouslySetInnerHTML={{__html: this.props.searchCode}}/>: null}
            </div>
            <a className="SiteSearch__link-close"
               href="#"
               onClick={this.handleClick}
            />
          </div>
        </div>
        <a className="SiteSearch__link-open"
           href="#"
           onClick={this.handleClick}
        />
      </div>
    )
  }

  //
  handleClick = (e) => {
    e.preventDefault();
    //
    let search_input = null;
    const formElement = this.refs.code.getElementsByClassName('js-SearchForm')[0] || null;
    if (formElement) {
      search_input = formElement.querySelector('.js-SearchForm_kw')
    }
    if (this.state.open === true) {
      if (search_input) {
        search_input.blur();
      }
      //
      this.setState({
        open: false,
        height: 0,
      });
    } else {
      if (search_input) {
        search_input.focus();
      }
      //
      this.setState({
        open: true,
        height: window.innerHeight - 80,
      });
      //
      setTimeout(() => {
        if (this.props.scrollToSearchTop !== null) this.props.scrollToSearchTop(this.refs.content.getBoundingClientRect().top - 80);
      }, 100);
    }
  };

}

export default SiteSearchMb;



// WEBPACK FOOTER //
// ./src/containers/site-search/mb.jsx